import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import getVacancyResponsesAPI from '../../api/get-vacancy-responses';
import { IVacancyResponsesRegister } from '../../utils/types/admin-types';
import {
  getVacansyResponsesReceive,
  getVacansyResponsesReject,
  getVacansyResponsesRequeste,
} from '../actions/admin-page';

interface IGetVacancyAction {
  type: string;
  payload: {
    vacancyId: string;
    viewed: string;
    recomendation: string
  }
}

interface IVacancyResponses {
  responseRegister: IVacancyResponsesRegister;
}

const getVacansyResponses = function* getVacansyResponses(action: IGetVacancyAction) {
  try {
    const response: IVacancyResponses = yield call(
      getVacancyResponsesAPI,
      action.payload.vacancyId,
      action.payload.viewed,
      action.payload.recomendation,
    );
    yield put(getVacansyResponsesReceive({ vacancy: response }));
  } catch (error) {
    yield put(getVacansyResponsesReject({ error }));
  }
};

export default function* getVacansyResponsesWatcher() {
  yield takeLatest(getVacansyResponsesRequeste, getVacansyResponses);
}
